import styled from 'styled-components'
import {MobileBurger} from "@/src/shared/ui/layout/ui/header/burger";
import theme, {media} from '@/src/config/theme'

export const MobileButton = styled(MobileBurger)`
  @media ${media.lg} {
    display: none;
  }
    
  justify-content: center;

  border-color: ${theme.colors.white}80;
  color: ${theme.colors.textDark};

  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primary};
    background: transparent;
  }
`